import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-datos-unicos',
	templateUrl: './datos-unicos.component.html',
	styleUrls: ['./datos-unicos.component.css']
})
export class DatosUnicosComponent implements OnInit {

	@Input() PreguntasUnicas: FormGroup
	constructor() { }

	ngOnInit(): void {
		console.log(this.PreguntasUnicas.get('pregunta').value)
	}

}
